import { NotFound } from "components/notFound";
import { Route, Routes } from "react-router";
import { ManageUsers } from "components/users/manage";
import { PermissionsOverview } from "components/users/permissionsOverview/permissionsOverview";
import { useIsAdmin } from "hooks/settings";
import DeliveryFormPage from "components/deliveryForm/page";
import { CacheAdminPage } from "components/cacheAdmin/page";
import ScrapEyeDeviceDataPage from "components/scrapEyeDataDashboard/ScrapEyeDeviceDataPage";
import ScrapEyeDataDashboardPage from "components/scrapEyeDataDashboard/ScrapEyeDataDashboardPage";
import ModelDashboardPage from "components/scrapEyeDataDashboard/modelDashboard/ModelDashboardPage";
import { ProvideScrapEyeMetadata } from "contexts/scrapEyeMetadata";

export const AdminRoutes = () => {
  const isAdmin = useIsAdmin();
  return isAdmin ? (
    <Routes>
      <Route path="/users" element={<ManageUsers />} />
      <Route path="/permissions-overview" element={<PermissionsOverview />} />
      <Route path="/delivery-form" element={<DeliveryFormPage />} />
      <Route path="/delivery-form/:formId" element={<DeliveryFormPage />} />
      <Route path="/cache-admin" element={<CacheAdminPage />} />
      <Route path="/scrap-eye/*" element={<ScrapEyeRoutes />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  ) : (
    <NotFound />
  );
};

export const ScrapEyeRoutes = () => {
  return (
    <ProvideScrapEyeMetadata>
      <Routes>
        <Route
          path="/data-dashboard/:tabKey?"
          element={<ScrapEyeDataDashboardPage />}
        />
        <Route path="/model-dashboard" element={<ModelDashboardPage />} />
        <Route
          path="/data-dashboard/device/:deviceName/:tabKey?"
          element={<ScrapEyeDeviceDataPage />}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </ProvideScrapEyeMetadata>
  );
};
